export default "__VITE_ASSET__317ef4a6__"